import React from 'react';

const SentimentBullet = ({ 
  circleClassName = 'fill-gray-dark', 
  symbolClassName = 'stroke-white fill-white', 
  className = '',
  sentiment = 'neutral'
}) => {
  const renderSymbol = () => {
    switch(sentiment) {
      case 'positive':
        return (
          <>
            <circle cx="8" cy="8.77148" r="8" className={circleClassName} />
            <path d="M8 4.77148V12.7715M12 8.77148L4 8.77148" strokeWidth="1.5" strokeLinecap="round" className={symbolClassName} />
          </>
        );
      case 'negative':
        return (
          <>
            <circle cx="8" cy="8.77148" r="8" className={circleClassName} />
            <path d="M12 8.77148L4 8.77148" strokeWidth="1.5" strokeLinecap="round" className={symbolClassName} />
          </>
        );
      case 'neutral':
      default:
        return (
          <>
            <path d="M13.6569 3.11463C16.781 6.23882 16.781 11.3041 13.6569 14.4283C10.5327 17.5525 5.46734 17.5525 2.34315 14.4283C-0.781049 11.3041 -0.781049 6.23882 2.34315 3.11463C5.46734 -0.0095644 10.5327 -0.0095644 13.6569 3.11463Z" className={circleClassName} />
            <circle cx="8" cy="8.77148" r="3" className={symbolClassName} />
          </>
        );
    }
  };

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" className={`shrink-0 w-4 mr-3 ${className}`} >
      {renderSymbol()}
    </svg>
  );
};

export default SentimentBullet;
